// discount
export const DISCOUNT_TYPES = {
  all: 'all',
  bundle: 'bundle',
  buyMoreSaveMore: 'mixandmatch',
  daily: 'daily',
  sale: 'sale',
  mixandmatch: 'mixandmatch',
  ongoing: 'ongoing',
};

export const DISCOUNT_ROUTE_MAP = {
  all: 'all',
  bundle: 'bundle',
  // remove after July 2024
  buyMoreSaveMore: 'mix-and-match',
  daily: 'daily-deals',
  mixandmatch: 'mix-and-match',
  sale: 'sales',
  ongoing: 'ongoing',
};
